/* DSL Instant search — debounced AJAX search via /search/suggest.json */
(function(){
  var input = document.querySelector("input[type=search][name=q]");
  if (!input) return;
  var dropdown = document.createElement("div");
  dropdown.className = "dsl-instant-search";
  dropdown.hidden = true;
  input.parentNode.appendChild(dropdown);
  var t;
  input.addEventListener("input", function(){
    clearTimeout(t);
    var q = input.value.trim();
    if (q.length < 2) { dropdown.hidden = true; return; }
    t = setTimeout(function(){
      fetch("/search/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=product&resources[limit]=6").then(function(r){return r.json();}).then(function(d){
        var prods = (d.resources && d.resources.results && d.resources.results.products) || [];
        if (!prods.length) { dropdown.hidden = true; return; }
        dropdown.innerHTML = prods.map(function(p){
          return "<a class=\"dsl-instant-search__item\" href=\"" + p.url + "\"><img src=\"" + p.image + "\" width=\"40\" height=\"40\" alt=\"\" loading=\"lazy\"><span><strong>" + p.title + "</strong><br>€" + p.price.replace(/[^\d,.]/g,"") + "</span></a>";
        }).join("");
        dropdown.hidden = false;
        if (window.DSL_AB) window.DSL_AB.track("instant_search", {q: q, results: prods.length});
      });
    }, 200);
  });
  input.addEventListener("blur", function(){ setTimeout(function(){ dropdown.hidden = true; }, 200); });
})();